















import { Component, Prop, Watch } from 'vue-property-decorator';
import FormFooter from '@/components/FormFooter.vue';
import FormBase from '@/mixins/FormBase';
import { Action } from 'vuex-class';
import ZetaHubzone from '@/core/interfaces/ZetaHubzone';

@Component({
    components: { FormFooter },
})
export default class ZetaHubZoneForm extends FormBase<ZetaHubzone> {
    @Prop({ required: true, type: Number })
    farmId!: number;

    @Action('saveZetaHubZone')
    saveAction!: (zetaHubZone: Partial<ZetaHubzone>) => Promise<ZetaHubzone>;

    name = '';

    @Watch('initial', { immediate: true })
    setFromInitial(): void {
        if (!this.initial) {
            return;
        }

        this.name = this.initial.name || '';
    }

    get parseForm(): Partial<ZetaHubzone> {
        return {
            ...this.initial,
            id: this.initial?.id || undefined,
            name: this.name,
        };
    }
}

